export default "__VITE_ASSET__fd0ba34a__"